
const $ = window.jQuery;
const $window = window.$window || $(window);

module.exports = {
  init: function () {
    /*
Show hide menu on scroll
=============================================== */
    var didScroll;
    var lastScrollTop = 0;
    var delta = 5;
    var navbarHeight = $("header").outerHeight();
    //console.log(navbarHeight);
    $(window).scroll(function (event) {
      didScroll = true;
      //console.log("scrolling");
    });

    setInterval(function () {
      if (didScroll) {
        hasScrolled();
        didScroll = false;
      }
    }, 250);

    function hasScrolled() {
      var st = window.scrollY || document.documentElement.scrollTop;
      //console.log("st", st);

      // Make sure they scroll more than delta
      if (Math.abs(lastScrollTop - st) <= delta) {
        return;
      }

      // If they scrolled down and are past the navbar, add class .nav-up.
      // This is necessary so you never see what is "behind" the navbar.
      if (st > lastScrollTop && st > navbarHeight) {
        // Scroll Down
        $(".sticky")
          .removeClass("nav-down")
          .addClass("nav-up");
        $("header")
          .removeClass("nav-down top-0")
          .addClass("nav-up -top-30");
        $('.menu-item-has-children').addClass('disable-scroll');
      } else {
        // Scroll Up
        if (st + $(window).height() < $(document).height()) {
          $(".sticky")
            .removeClass("nav-up top-0")
            .addClass("nav-down top-0");
          $("header")
            .removeClass("nav-up -top-30 ")
            .addClass("nav-down top-0");
          $('.menu-item-has-children').removeClass('disable-scroll');
        }
      }
      lastScrollTop = st;
    }
    /*
    Scrolling adds menu fixed class
    =============================================== */
    // fixed class scroll down
    $(window).scroll(function () {
      if ($(window).scrollTop() > 0) {
        $("header").addClass("scrolled");
      } else {
        $("header").removeClass("scrolled");
      }
    });
    // detecet if page is loaded on top or not 
    $(window).on('load', function () {
      let scrollTop = document.documentElement.scrollTop;

      //console.log('scrollTop', scrollTop);

      let { left, top } = $('header').offset();

      //console.log('header top', top);

      if (scrollTop === 0) {
        // we're at the top don't to anything
      } else {
        $(' header').addClass('scrolled');
      }
    });
    // Cookie close topbar
    jQuery('.topBar').cookieBar({
      closeButton: '.accept',
      hideOnClose: false,
      secure: false,
      expiresDays: 1,
    })
    jQuery('.topBar').on('cookieBar-close', function () {
      jQuery(this).slideUp()
    })
    $(".topBar-readmore").on('click', function () {
      window.location = this.href;
    });
  },
};
